import { Divider, Flex } from 'antd';
import { ReadingStatus } from 'infrastructure/enums';

import ReadingsList from '../../patient-readings/readings-list';
import ThresholdsList from '../../patient-readings/thresholds-list';
import s from './styles.module.scss';

import type { FC } from 'react';
import type { ReadingType } from 'infrastructure/enums/reading-type';
import type {
  TStatuses,
  Value,
} from 'infrastructure/interfaces/i-rpm-patient-activity';
import type { IPatientThresholds } from 'infrastructure/interfaces/i-patient-thresholds';

interface PatientActivityListProps {
  patientGuid: string;
  globalStatus: ReadingStatus;
  values: Value;
  statuses: TStatuses;
  readingType: ReadingType;
  thresholds: IPatientThresholds;
}

const PatientActivityList: FC<PatientActivityListProps> = ({
  patientGuid,
  globalStatus,
  values,
  statuses,
  readingType,
  thresholds,
}) => {
  return (
    <Flex vertical className={s.content}>
      <Flex align="stretch" gap={8}>
        <ReadingsList
          id={patientGuid}
          values={values}
          statuses={statuses}
          justify="start"
        />
        {globalStatus !== ReadingStatus.Normal.toString() && (
          <Divider type="vertical" className={s['reading-threshold-divider']} />
        )}
        <ThresholdsList
          id={patientGuid}
          globalStatus={globalStatus}
          values={values}
          statuses={statuses}
          readingType={readingType}
          thresholds={thresholds}
          justify="start"
        />
      </Flex>
    </Flex>
  );
};

export default PatientActivityList;
